module.exports = __webpack_public_path__ + "img/home3.8ffe3762.png";